// @todo Make this shorter
var lastSearch = '';
AddPageSwapTrigger(function() {
    var params = $.deparam(document.location.search.substring(1));

    if(params.name && params.name.length) {
        lastSearch = params.name;
    }
    else if(params.zoek && params.zoek.length) {
        lastSearch = params.zoek;
    }
    else if(params.search && params.search.length) {
        lastSearch = params.search;
    }
    else if(params.suche && params.suche.length) {
        lastSearch = params.suche;
    }
	else if(params.szukaj && params.szukaj.length) {
        lastSearch = params.szukaj;
    }
	else if(params.cercare && params.cercare.length) {
        lastSearch = params.cercare;
    }
	else if(params.buscar && params.buscar.length) {
        lastSearch = params.buscar;
    }
	else if(params.chercher && params.chercher.length) {
        lastSearch = params.chercher;
    }
    var matches = document.location.pathname.match('\\\/search\\\/(.+)');
    if(matches && matches[1] && matches[1].length) {
        lastSearch = matches[1];
    }

    lastSearch = decodeURI(lastSearch);

    $('#search_product').val(lastSearch);
    $('#search_product_mobile').val(lastSearch);

    $('#search_product_mobilenav').val(lastSearch);
    $('#search_action_global').val(lastSearch);
    $('#search_action_local').val(lastSearch);
    $('#search_action_mobile').val(lastSearch);
    $('#home_search_text').val(lastSearch);
    $('#home_search_text_mobile').val(lastSearch);
    $('#search_bar_local').val(lastSearch);
    $('#search_bar_local_mobile').val(lastSearch);
    $('#national_search_text').val(lastSearch);
    $('#national_search_text_mobile').val(lastSearch);
    $('#search_mobile_query').val(lastSearch);
})